// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"836ed900","239":"6d4e401c","488":"a1378170","849":"2f225a29","977":"aea90c08"}[chunkId] + ".chunk.js";
};